import { delayWithJitter } from '~/assets/js/utils/delay'
import { onLoad } from '~/assets/js/utils/dom'

/**
 * this plugin is temporary and only serves to remove the service worker installed in the users browser since we will
 * no longer support it in the project
 *
 * it's safe to remove this plugin after dez/2022
 *
 * @returns {Promise<void>}
 */
export default async function () {
  await onLoad()

  setTimeout(async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        registrations.forEach(registration => registration.unregister())
      }
    } catch (_error) {}
  }, delayWithJitter())
}
